import React from "react";
import styled from "styled-components";
import { Search } from "lucide-react";

const FilterContainer = styled.div`
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  max-width: 300px;

  input {
    width: 100%;
    padding: 0.75rem 1rem 0.75rem 3rem;
    border: 1px solid ${(props) => props.theme.colors.border.medium};
    border-radius: ${(props) => props.theme.borderRadius.full};
    font-size: ${(props) => props.theme.typography.body};
    outline: none;
    transition: border-color ${(props) => props.theme.transitions.fast};

    &:focus {
      border-color: ${(props) => props.theme.colors.primary};
    }
  }

  svg {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${(props) => props.theme.colors.text.tertiary};
  }
`;

const FilterTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const FilterTag = styled.button`
  padding: 0.5rem 1rem;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme.colors.primary
        : props.theme.colors.border.medium};
  background-color: ${(props) =>
    props.active ? props.theme.colors.primary : "transparent"};
  color: ${(props) =>
    props.active
      ? props.theme.colors.text.inverse
      : props.theme.colors.text.secondary};
  border-radius: ${(props) => props.theme.borderRadius.full};
  font-size: ${(props) => props.theme.typography.small};
  cursor: pointer;
  transition: all ${(props) => props.theme.transitions.fast};

  &:hover {
    border-color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) =>
      props.active
        ? props.theme.colors.primaryHover
        : props.theme.colors.primaryLight};
    color: ${(props) =>
      props.active
        ? props.theme.colors.text.inverse
        : props.theme.colors.primary};
  }
`;

export const FilterSection = ({
  searchTerm,
  onSearchChange,
  searchPlaceholder = "Search...",
  filterOptions,
  activeFilter,
  onFilterChange,
  maxFilters = 8,
}) => {
  return (
    <FilterContainer>
      <SearchContainer>
        <Search size={20} />
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </SearchContainer>

      <FilterTags>
        {filterOptions.slice(0, maxFilters).map((filter) => (
          <FilterTag
            key={filter}
            active={activeFilter === filter}
            onClick={() => onFilterChange(filter)}
          >
            {filter}
          </FilterTag>
        ))}
      </FilterTags>
    </FilterContainer>
  );
};
